var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app_modal", class: _vm.isOpen ? "open" : "" },
    [
      _c(
        "div",
        { staticClass: "modal_inner", attrs: { "data-type": _vm.type } },
        [
          _c("div", { staticClass: "modal_title" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.modalParams[_vm.type]["title"]) +
                "\n        "
            )
          ]),
          _vm.type == "country"
            ? _c("div", { staticClass: "modal_content" }, [
                _c("div", { staticClass: "input_glass" }),
                _c("input", {
                  staticClass: "modal_input",
                  attrs: {
                    type: "text",
                    id: "CountriesInput",
                    autocomplete: "off",
                    placeholder: "eg: France"
                  },
                  on: {
                    keyup: function($event) {
                      return _vm.searchInputKeyup($event)
                    },
                    focus: function($event) {
                      return _vm.focusInput($event)
                    },
                    blur: function($event) {
                      return _vm.blurInput()
                    }
                  }
                }),
                _c(
                  "div",
                  {
                    staticClass: "modal_suggestions",
                    class: _vm.displayAutocomplete ? "displayed" : ""
                  },
                  _vm._l(_vm.autocompleteCountries, function(
                    countryObj,
                    countryIndex
                  ) {
                    return _c(
                      "nuxt-link",
                      {
                        staticClass: "suggestion_country",
                        attrs: { to: "/country/" + countryObj.iso3 }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(countryObj.country_name) +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  1
                )
              ])
            : _vm.type == "dataset"
            ? _c(
                "div",
                { staticClass: "modal_content" },
                [
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "modal_bt",
                      attrs: { to: "/dataset/global-profit" }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "Global profit shifting by multinational enterprises"
                        )
                      ])
                    ]
                  ),
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "modal_bt",
                      attrs: { to: "/dataset/offshore-financial" }
                    },
                    [_c("span", [_vm._v("Offshore financial wealth")])]
                  ),
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "modal_bt",
                      attrs: { to: "/dataset/offshore-real-estate" }
                    },
                    [_c("span", [_vm._v("Offshore real estate wealth")])]
                  ),
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "modal_bt",
                      attrs: { to: "/dataset/effective-tax" }
                    },
                    [
                      _c("span", [
                        _vm._v("Effective tax rates on capital and labor")
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "modal_backbt",
              on: {
                click: function($event) {
                  return _vm.closeModal()
                }
              }
            },
            [_vm._v("\n            Go back\n        ")]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f1516972", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1516972","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/appModal.vue
// module id = k3Xg
// module chunks = 0 1 2 3 4 5 6